export default "__VITE_ASSET__CnzxGvRA__"